import { defineMessages } from 'react-intl';

const navMessages = defineMessages({
  welcome: {
    id: 'nav.welcome',
    defaultMessage: 'Home',
  },
  work: {
    id: 'nav.work',
    defaultMessage: 'Work',
  },
  projects: {
    id: 'nav.projects',
    defaultMessage: 'Projects',
  },
  contact: {
    id: 'nav.contact',
    defaultMessage: 'Contact',
  },
  teaching: {
    id: 'nav.teaching',
    defaultMessage: 'Teaching',
  },
});

export default navMessages;
